/**
 * Footer Component - Site footer with links and information
 */

import { ContentBlock } from 'braid-design-system';
import type React from 'react';
import { Link } from 'react-router';

import { GALLERY_ENABLED } from '../../constants/features.mjs';
import Logo from '../Header/logo-green.png';
import { NewsletterSignup } from '../NewsletterSignup/NewsletterSignup';

import * as styles from './Footer.css';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <ContentBlock width="large">
        <div className={styles.footerContent}>
          <div className={styles.footerSection}>
            <Link to="/">
              <img src={Logo} alt="Fae Forest" className={styles.footerLogo} />
            </Link>
            {/* <NewsletterSignup /> */}
          </div>

          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>Quick Links</h3>
            <Link to="/about-us" className={styles.footerLink}>
              About Us
            </Link>
            <Link to="/products" className={styles.footerLink}>
              Products
            </Link>
            {GALLERY_ENABLED && (
              <Link to="/gallery" className={styles.footerLink}>
                Gallery
              </Link>
            )}
            <Link to="/custom-orders" className={styles.footerLink}>
              Custom Orders
            </Link>
          </div>

          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>Help</h3>
            <Link to="/faq" className={styles.footerLink}>
              FAQ
            </Link>
            <Link to="/care-guide" className={styles.footerLink}>
              Care & Painting Guide
            </Link>
            <Link to="/shipping-and-returns" className={styles.footerLink}>
              Shipping and Returns
            </Link>
            <Link to="/privacy" className={styles.footerLink}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={styles.footerLink}>
              Terms of Service
            </Link>
          </div>

          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>Connect</h3>
            <Link to="/contact" className={styles.footerLink}>
              Contact us
            </Link>
            <a
              href="https://www.myminifactory.com/users/FaeForest"
              className={styles.footerLink}
            >
              MyMiniFactory
            </a>
            <a
              href="https://cults3d.com/@FaeForest"
              className={styles.footerLink}
            >
              Cults3D
            </a>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>© {currentYear} Fae Forest. All rights reserved.</p>
        </div>
      </ContentBlock>
    </footer>
  );
};
